import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

const CallToActionTwo = () => {
  const data = useStaticQuery(graphql`
    {
      strapiHomePage {
        CallToActionTwo_title
        CallToActionTwo_description1
        CallToActionTwo_description2
        CallToActionTwo_img {
          publicURL
        }
      }
    }
  `);

  const {
    strapiHomePage: {
      CallToActionTwo_title,
      CallToActionTwo_description1,
      CallToActionTwo_description2,
      CallToActionTwo_img,
    },
  } = data;

  return (
    <section className='cta-two'>
      <div className='container'>
        <img
          src={CallToActionTwo_img.publicURL}
          className='cta-two__moc'
          alt='alter text'
        />
        <div className='row'>
          <div className='col-lg-6'>
            <div className='cta-two__content'>
              <i className='cta-two__icon dimon-icon-data'></i>
              <div className='block-title text-left'>
                <h2 className='block-title__title'>{CallToActionTwo_title}</h2>
              </div>
              <div className='cta-two__text'>
                <p>{CallToActionTwo_description1}</p>
                <p>{CallToActionTwo_description2}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default CallToActionTwo;
